import type { UnresolvedDepartment, User } from '@bliks-io/contracts';

type ResolvableDepartment = Pick<UnresolvedDepartment, '_id' | 'managerEmail'>;

/** The user the department's manager email names. */
export function managerEmailMatch(
  department: ResolvableDepartment,
  emailToUser: Map<string, User>
): User | undefined {
  return department.managerEmail
    ? emailToUser.get(department.managerEmail.toLowerCase())
    : undefined;
}

/**
 * The manager a department resolves to. A touched department (key present)
 * uses its stored value: the empty-string clear sentinel reads as no manager
 * and does NOT fall back to the email match; only an untouched one does.
 */
export function effectiveManagerId(
  department: ResolvableDepartment,
  managerAssignments: Map<string, string>,
  emailToUser: Map<string, User>
): string | undefined {
  return managerAssignments.has(department._id)
    ? managerAssignments.get(department._id)
    : managerEmailMatch(department, emailToUser)?._id;
}
